// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Antique Olive T Compact Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/NeueHaasDisplayRoman.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/NeueHaasDisplayMediu.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "antique-olive-compact";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "neue-haas-grotesk-display-roman";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "neue-haas-grotesk-display-medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

* {
  width: 100%;
  overflow-x: hidden;
  font-family: neue-haas-grotesk-display-roman;
  background-color: #f4f1e0;
}

h2 {
  font-family: neue-haas-grotesk-display-medium;
}

p {
  font-family: neue-haas-grotesk-display-roman;
}

/* NAV BAR */

.navbar-header h1 {
  font-family: antique-olive-compact;
  font-weight: 600;
  color: black;
  font-size: 1380%;
  letter-spacing: 6px;
  color: #b4b2e3;
}

@media screen and (max-width: 1600px) {
  .navbar-header h1 {
    font-size: 1150%;
    display: inline;
    padding-top: 0%;
  }

  a {
    line-height: 150%;
  }
}

@media screen and (max-width: 1300px) {
  .navbar-header h1 {
    font-size: 1000%;
  }
}

@media screen and (max-width: 1150px) {
  .navbar-header h1 {
    font-size: 800%;
  }
}

@media screen and (max-width: 1000px) {
  .navbar-header h1 {
    font-size: 700%;
  }
}

@media screen and (max-width: 900px) {
  .navbar-header h1 {
    font-size: 500%;
  }
}

@media screen and (max-width: 600px) {
  .navbar-header h1 {
    font-size: 400%;
  }
}

@media screen and (max-width: 500px) {
  .navbar-header h1 {
    font-size: 300%;
  }
}

@media screen and (max-width: 400px) {
  .navbar-header h1 {
    font-size: 200%;
  }
}

.navbar-links {
  align-items: center !important;
  display: inline-block;
  vertical-align: middle;
  color: #b4b2e3;
}

.navbar-links .navbar-link {
  color: #808080;
  align-items: center !important;
  display: inline-block;
  vertical-align: middle;
  width: 25%;
  text-align: center;
  color: #b4b2e3;

}


.navbar-links .navbar-nav {
  align-items: center !important;
  display: inline;
  vertical-align: middle;
  color: #b4b2e3;

}

.Nav-bar-general {
  align-items: center;
  line-height: 3.5;
  display: inline-block;
  vertical-align: middle;
  color: #b4b2e3;

}


/* NavBar CSS */
nav.navbar a.navbar-brand {
  width: 50%;
  padding-left: 5%;
}

nav.navbar .navbar-nav .nav-link.navbar-link {
  font-weight: 800;
  padding-right: 5%;
  letter-spacing: 0.8px;
  padding-top: 2.2%;
  font-size: 18px;
  opacity: 0.75;
  color: #b4b2e3;
}

nav.navbar .navbar-nav a.nav-link.navbar-link:hover,
nav.navbar .navbar-nav a.nav-link.navbar-link.active {
  opacity: 1;
}

span.navbar-text {
  display: flex;
  align-items: center;
}

.navbar-text button {
  font-weight: 700;
  color: #fff;
  border: 1px solid #fff;
  padding: 2% 2%;
  font-size: 1em;
  margin-left: 1%;
  position: relative;
  background-color: transparent;
  transition: 0.3s ease-in-out;
}

.navbar-text button span {
  z-index: 1;
}

.navbar-text button::before {
  content: "";
  width: 0%;
  height: 100%;
  position: absolute;
  background-color: #b4b2e3;
  left: 0;
  top: 0;
  z-index: -1;
  transition: 0.3s ease-in-out;
  color: #b4b2e3;
}

.navbar-text button:hover {
  color: #121212;
}

.navbar-text button:hover::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
}

nav.navbar .navbar-toggler:active,
nav.navbar .navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}

nav.navbar .navbar-toggler-icon {
  width: 24px;
  height: 17px;
  background-image: none;
  position: relative;
  border-bottom: 2px solid #fff;
  transition: all 300ms linear;
  top: -2px;
}

nav.navbar .navbar-toggler-icon:focus {
  border-bottom: 2px solid #fff;
}

nav.navbar .navbar-toggler-icon:after,
nav.navbar .navbar-toggler-icon:before {
  width: 24px;
  position: absolute;
  height: 2px;
  background-color: #fff;
  top: 0;
  left: 0;
  content: '';
  z-index: 2;
  transition: all 300ms linear;
}

nav.navbar .navbar-toggler-icon::after {
  top: 8px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon::after {
  transform: rotate(45deg);
  border-color: #fff;
  height: 2px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon::before {
  transform: translateY(8px) rotate(-45deg);
  border-color: #fff;
  height: 2px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  border-color: transparent;
}

nav.navbar.scrolled {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}


/* BANNER */

hr.solid {
  border-top: 5px solid #808080;
  padding: 0;
  padding-bottom: 1%;
  z-index: 0;
}

.banner {
  align-items: center;
  display: inline-block;
  vertical-align: middle;
  width: 100%;


  .section-container {
    padding: 6px;
    position: relative;
    text-align: center;
    color: white;

    .centered {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      width: 100%;
      z-index: 0;
    }

    .centered p {
      text-decoration: none;
      color: white !important;
      font-size: 60px;
      font-weight: 7400;
    }
  }

}


/* SECTIONS*/
.sections {

  h2 {
    padding-top: 4%;
    padding-bottom: 4%;
    font-weight: 200;
    color: #b4b2e3;
  }

  img {
    padding: 10px 10px 10px 10px;
    object-fit: cover;
  }

  p {
    font-size: 1.1em;
    margin-top: 5px;
    letter-spacing: 0.8px;
    line-height: 1.5em;
    text-align: justify;
    text-justify: inter-word;
    padding-left: 22%;
    padding-right: 22%;
  }

  .illustration {
    padding-left: 10%;
    padding-right: 10%;

    .firstRow {
      display: grid;
      grid-template-columns: 1fr 3fr;

      .twoImages {
        display: block;
        grid-template-columns: 1fr 1fr;
      }
    }

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .threeImages {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .threeImages {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .enviromentDesign {
    padding-left: 10%;
    padding-right: 10%;

    .firstRow {
      display: grid;
      grid-template-columns: 1.3fr 1.7fr;

      .twoImages {
        display: block;
        grid-template-columns: 1fr 1fr;
      }
    }

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .threeImages {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .threeImages {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .characterDesign {
    padding-left: 10%;
    padding-right: 10%;

    .firstRow {
      display: grid;
      grid-template-columns: 1fr 2fr;

      .twoImages {
        display: block;
        grid-template-columns: 1fr 1fr;
      }
    }

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .threeImages {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .threeImages {
        display: grid;
        grid-template-columns: 1fr;
      }
    }

    .twoImages-2-1 {
      display: grid;
      grid-template-columns: 2fr 1fr;
    }
  }

  .dWork {
    padding-left: 10%;
    padding-right: 10%;

    .firstRow {
      display: grid;
      grid-template-columns: 1fr 2fr;

      .twoImages {
        display: block;
        grid-template-columns: 1fr 1fr;
      }
    }

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .threeImages {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    .specialRow {
      display: grid;
      grid-template-columns: 0.8fr 1.2fr;

      .threeImages {
        display: block;
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    @media screen and (max-width: 480px) {
      .threeImages {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .NDA {
    padding-left: 10%;
    padding-right: 10%;

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .twoImages2 {
      display: grid;
      grid-template-columns: 1.34fr 0.76fr;
    }

    .twoImages-1-3 {
      display: grid;
      grid-template-columns: 1fr 2fr;
    }

  }

  .specialRow {
    display: grid;
    grid-template-columns: 0.89fr 2.11fr;

    .twoImages {
      display: block;
      grid-template-columns: 1fr 1fr;
    }
  }

  .specialRow2 {
    display: grid;
    grid-template-columns: 1.4fr 1.6fr;

    .twoImages {
      display: block;
      grid-template-columns: 1fr 1fr;
    }
  }

}

/* FOOTER */

.footer {
  width: 100%;

  .social-icon {
    margin-top: 1%;
    display: inline-block;
    margin-left: 14px;
    margin-bottom: 20px;
    width: 100%;
  }

  .social-icon a {
    display: inline-flex;
    width: 55px;
    height: 55px;
    background: rgba(217, 217, 217, 0.1);
    margin-right: 3%;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .social-icon a::before {
    background-color: #D3D3D3;
    border-radius: 50%;
    transform: scale(0);
    width: 55x;
    height: 55px;
    position: absolute;
    transition: 0.3s ease-in-out;
  }

  .social-icon a img {
    z-index: 1;
    width: 80%;
    transition: 0.3s ease-in-out;
  }

  .social-icon a:hover img {
    filter: brightness(0.5) saturate(20%);
  }

}

footer {
  width: 100%;
}


/* ABOUT */

.about {
  padding-left: 11%;
  padding-right: 11%;

  .aboutBox {
    margin: 2% auto;
    border-radius: 5px;
    padding: 1%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: 1.7fr 1fr;
    padding-left: 3%;
    padding-right: 2%;
    padding-top: 2%;
    padding-bottom: 2%;
    background-color: #f6cd45;
    background: #f6cd45;
    border-radius: 30px;


    .leftBox {
      background-color: #f6cd45;
      position: relative;
    }

    .righBox {
      background-color: #f6cd45;
    }

    .aboutLinks {
      background: #f6cd45;
      display: grid;
      grid-template-columns: 1fr 1fr;
      position: absolute;
      bottom: 0;
      align-items: flex-end;
    }


    .contact {
      background: #f6cd45;
    }

    .social-icon {
      display: flex;
      flex-direction: row-reverse;
      padding-right: 16%;
      background-color: #f6cd45;
      position: relative;
    }

    .social-icon a {
      width: 3.5em;
      height: 3.5em;
      background: #f6cd45;
      margin-right: 3%;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .social-icon a img {
      width: 80%;
      background-color: #f6cd45;
    }

    .social-icon a:hover img {
      background-color: #0932ba;
      filter: invert(1);
    }

    .photo {
      border-radius: 15px;
    }

    a {
      text-decoration: none;
      color: black;
    }

    button {
      display: flex;
      width: 50%;
      height: 5%;
      background-color: #f6cd45;
      padding-left: 4%;
      padding-right: 4%;
      padding-top: 3%;
      padding-bottom: 3%;
      align-items: center;
      justify-content: center;
      border-radius: 30px;
      text-decoration: none;
      color: black;
      overflow-y: hidden;
      font-weight: 800;
      font-size: 1.2em;

      img {
        background: #f6cd45;
        width: 30%;
        padding-right: 7%;
      }
    }

    button:hover {
      background: #cfac3a;

      img {
        background: #cfac3a;
      }
    }

    h2 {
      font-size: 7em;
      margin-bottom: 10%;
      margin-top: 0%;
      display: flex;
      background-color: #f6cd45;
      background: #f6cd45;
    }

    p {
      font-size: 1.2em;
      padding-right: 10%;
      margin-bottom: 5%;
      letter-spacing: 0.8px;
      line-height: 1.5em;
      text-align: justify;
      text-justify: inter-word;
      background-color: #f6cd45;
      font-weight: 800;
    }
  }
}

@media screen and (max-width: 1500px) {
  .about {
    .aboutBox {
      grid-template-columns: 1.9fr 0.8fr;

      h2 {
        font-size: 4em;
      }

      .photo{
        margin-bottom: 20%;
      }

      p {
        font-size: 1em;
      }

      button {
        width: 60%;
        height: 10%;
      }
    }
  }
}

@media screen and (max-width: 1250px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }


      p {
        font-size: 0.9em;
      }

      .aboutLinks {
        margin-top: 5%;
      }

      button {

        width: 70%;
      }
    }
  }
}

@media screen and (max-width: 1100px) {
  .about {
    .aboutBox {
      .social-icon {
        display: flex;
        flex-direction: row;
        padding-right: 0%;
        padding-top: 5%;
      }

      h2 {
        font-size: 3em;
      }
      .photo{
        margin-bottom: 40%;
      }
      p {
        font-size: 0.9em;
      }

      .social-icon a {
        width: 2.5em;
        height: 2.5em;
      }

      .social-icon a img {
        width: 70%;
      }

      button {
        width: 70%;
        font-size: 0.9em;

        img {
          width: 20%;
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
      }

    }
  }
}

@media screen and (max-width: 910px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 40%;
      }

    }
  }
}

@media screen and (max-width: 816px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 120%;
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 160%;
      }
    }
  }
}

@media screen and (max-width: 625px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 250%;
      }
      button {
        width: 70%;
        font-size: 0.9em;
        img {
          width: 0%;
        }
      }
    }
  }
}

@media screen and (max-width: 550px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 350%;
      }
      button {
        width: 80%;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 3em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 450%;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 2.5em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 650%;
      }
      button {
        width: 90%;
      }
    }
  }
}

@media screen and (max-width: 388px) {
  .about {
    .aboutBox {
      h2 {
        font-size: 2em;
      }
      .photo{
        margin-top: 60%;
        margin-bottom: 750%;
      }
      button {
        width: 100%;
      }
    }
  }
}

/* CONTACT */
.contact h2 {
  margin-bottom: 3%;
  margin-top: 5%;
  display: flex;
}

.contact p {
  font-size: 18px;
  margin-top: 5px;
  letter-spacing: 0.8px;
  line-height: 1.5em;
  width: 96%;
  text-align: justify;
  text-justify: inter-word;
}

.contact .contact-form {
  width: 100%;
  margin-top: 2%;
  margin-bottom: 2%;


  input[type='text'],
  input[type='email'] {
    width: 100%;
    max-width: 600px;
    height: 50px;
    font-size: 16px;
    padding: 0 20px;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    list-style: none;
    margin-bottom: 10px;
    overflow: hidden;
    display: block;
    position: relative;
    animation-fill-mode: forwards;
    border-color: transparent;
    border-bottom: 1px solid
  }

  textarea {
    width: 100%;
    max-width: 600px;
    margin-top: 10px;
    margin-bottom: 20px;
    height: 50px;
    font-size: 16px;
    min-height: 150px;
    display: block;
    box-sizing: border-box;
    border-color: transparent;
    border-bottom: 1px solid
  }

  .flat-button {
    color: white;
    font-size: large;
    background-color: black;
    font: 11px;
    letter-spacing: 3px;
    text-decoration: none;
    padding: 8px 10px;
    border: 2px solid black;
    width: auto;
    display: block;
  }
}

.not-found {
  width: 100%;
  margin-top: 20px;

  .flat-button {
    color: white;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: large;
    background-color: black;
    font: 11px;
    letter-spacing: 3px;
    text-decoration: none;
    padding: 8px 10px;
    border: 2px solid black;
    width: auto;
  }
}


/*  LOGIN  */
.login {

  .login-container {
    max-width: 400px;
    margin: 2% auto;
    border-radius: 5px;
    padding: 1%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #f4f1e0;
  }

  h2 {
    text-align: center;
    margin-bottom: 6%;
    font-weight: lighter;
  }

  .form-group {
    margin-bottom: 6%;
  }

  label {
    display: block;
    font-weight: bold;
  }

  input[type="text"],
  input[type="password"] {
    width: 100%;
    padding: 2%;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
  }

  button {
    width: 30%;
    padding: 2%;
    background-color: black;
    color: #fff;
    border: none;
    cursor: pointer;
  }

  button:hover {
    background-color: #222222;
  }

  span {
    display: block;
    padding-top: 3%;
    font-size: 1.2em;
    color: red;
    margin-top: 1%;
  }
}


/* POP UP MODAL */

.sections {
  .modal {
    left: 0;
    overflow-y: hidden;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    /*  to hide first time   */
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background-color: rgba(0, 0, 0, 0.5);
    max-width: calc(100% - 7%);
    max-height: calc(100% - 7%);

    img {
      background-color: white;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .close {
    position: fixed;
    width: 10%;
    height: 11%;
    background-color: transparent;
    color: #a9a9b5;
    border: none;
    cursor: pointer;
    top: 1%;
    right: 1%;
    font-size: 3em;
  }
}



/* APPLICATION */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,+DAA0E;AAC5E;;AAEA;EACE,8CAA8C;EAC9C,+DAA+D;AACjE;;AAEA;EACE,+CAA+C;EAC/C,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,YAAY;;AAEZ;EACE,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,cAAc;;AAEhB;;;AAGA;EACE,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;;AAEhB;;;AAGA,eAAe;AACf;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;;AAGA,WAAW;;AAEX;EACE,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;;;EAGX;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;;IAEZ;MACE,kBAAkB;MAClB,WAAW;MACX,QAAQ;MACR,SAAS;MACT,gCAAgC;IAClC;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;;IAEA;MACE,qBAAqB;MACrB,uBAAuB;MACvB,eAAe;MACf,iBAAiB;IACnB;EACF;;AAEF;;;AAGA,YAAY;AACZ;;EAEE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,8BAA8B;;MAE9B;QACE,cAAc;QACd,8BAA8B;MAChC;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,kCAAkC;;MAElC;QACE,cAAc;QACd,8BAA8B;MAChC;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,8BAA8B;;MAE9B;QACE,cAAc;QACd,8BAA8B;MAChC;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,8BAA8B;;MAE9B;QACE,cAAc;QACd,8BAA8B;MAChC;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE,aAAa;MACb,kCAAkC;;MAElC;QACE,cAAc;QACd,kCAAkC;MACpC;IACF;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,oCAAoC;IACtC;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;EAEF;;EAEA;IACE,aAAa;IACb,oCAAoC;;IAEpC;MACE,cAAc;MACd,8BAA8B;IAChC;EACF;;EAEA;IACE,aAAa;IACb,kCAAkC;;IAElC;MACE,cAAc;MACd,8BAA8B;IAChC;EACF;;AAEF;;AAEA,WAAW;;AAEX;EACE,WAAW;;EAEX;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;EACE,WAAW;AACb;;;AAGA,UAAU;;AAEV;EACE,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,uCAAuC;IACvC,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;;;IAGnB;MACE,yBAAyB;MACzB,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,8BAA8B;MAC9B,kBAAkB;MAClB,SAAS;MACT,qBAAqB;IACvB;;;IAGA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,2BAA2B;MAC3B,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;IAChB;;IAEA;MACE,UAAU;MACV,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,aAAa;MACb,UAAU;MACV,UAAU;MACV,yBAAyB;MACzB,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;;MAEhB;QACE,mBAAmB;QACnB,UAAU;QACV,iBAAiB;MACnB;IACF;;IAEA;MACE,mBAAmB;;MAEnB;QACE,mBAAmB;MACrB;IACF;;IAEA;MACE,cAAc;MACd,kBAAkB;MAClB,cAAc;MACd,aAAa;MACb,yBAAyB;MACzB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,qBAAqB;MACrB,kBAAkB;MAClB,mBAAmB;MACnB,wBAAwB;MACxB,yBAAyB;MACzB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE;IACE;MACE,kCAAkC;;MAElC;QACE,cAAc;MAChB;;MAEA;QACE,kBAAkB;MACpB;;MAEA;QACE,cAAc;MAChB;;MAEA;QACE,UAAU;QACV,WAAW;MACb;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;;;MAGA;QACE,gBAAgB;MAClB;;MAEA;QACE,cAAc;MAChB;;MAEA;;QAEE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;MACjB;;MAEA;QACE,cAAc;MAChB;MACA;QACE,kBAAkB;MACpB;MACA;QACE,gBAAgB;MAClB;;MAEA;QACE,YAAY;QACZ,aAAa;MACf;;MAEA;QACE,UAAU;MACZ;;MAEA;QACE,UAAU;QACV,gBAAgB;;QAEhB;UACE,UAAU;QACZ;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;MACjB;;IAEF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,kBAAkB;MACpB;;IAEF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,UAAU;QACV,gBAAgB;QAChB;UACE,SAAS;QACX;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,gBAAgB;MAClB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE;QACE,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,WAAW;MACb;IACF;EACF;AACF;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;;;EAGjB;;IAEE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB;EACF;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB;IACE,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;EACb;AACF;;;AAGA,YAAY;AACZ;;EAEE;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;EAChB;AACF;;;AAGA,iBAAiB;;AAEjB;EACE;IACE,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,2BAA2B;;IAE3B;MACE,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;EACF;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,eAAe;IACf,OAAO;IACP,SAAS;IACT,cAAc;EAChB;AACF;;;;AAIA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@font-face {\r\n  font-family: \"antique-olive-compact\";\r\n  src: url(\"./fonts/Antique Olive T Compact Regular.otf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"neue-haas-grotesk-display-roman\";\r\n  src: url(\"./fonts/NeueHaasDisplayRoman.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"neue-haas-grotesk-display-medium\";\r\n  src: url(\"./fonts/NeueHaasDisplayMediu.ttf\") format(\"truetype\");\r\n}\r\n\r\n* {\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  font-family: neue-haas-grotesk-display-roman;\r\n  background-color: #f4f1e0;\r\n}\r\n\r\nh2 {\r\n  font-family: neue-haas-grotesk-display-medium;\r\n}\r\n\r\np {\r\n  font-family: neue-haas-grotesk-display-roman;\r\n}\r\n\r\n/* NAV BAR */\r\n\r\n.navbar-header h1 {\r\n  font-family: antique-olive-compact;\r\n  font-weight: 600;\r\n  color: black;\r\n  font-size: 1380%;\r\n  letter-spacing: 6px;\r\n  color: #b4b2e3;\r\n}\r\n\r\n@media screen and (max-width: 1600px) {\r\n  .navbar-header h1 {\r\n    font-size: 1150%;\r\n    display: inline;\r\n    padding-top: 0%;\r\n  }\r\n\r\n  a {\r\n    line-height: 150%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1300px) {\r\n  .navbar-header h1 {\r\n    font-size: 1000%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1150px) {\r\n  .navbar-header h1 {\r\n    font-size: 800%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .navbar-header h1 {\r\n    font-size: 700%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .navbar-header h1 {\r\n    font-size: 500%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .navbar-header h1 {\r\n    font-size: 400%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .navbar-header h1 {\r\n    font-size: 300%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 400px) {\r\n  .navbar-header h1 {\r\n    font-size: 200%;\r\n  }\r\n}\r\n\r\n.navbar-links {\r\n  align-items: center !important;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  color: #b4b2e3;\r\n}\r\n\r\n.navbar-links .navbar-link {\r\n  color: #808080;\r\n  align-items: center !important;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 25%;\r\n  text-align: center;\r\n  color: #b4b2e3;\r\n\r\n}\r\n\r\n\r\n.navbar-links .navbar-nav {\r\n  align-items: center !important;\r\n  display: inline;\r\n  vertical-align: middle;\r\n  color: #b4b2e3;\r\n\r\n}\r\n\r\n.Nav-bar-general {\r\n  align-items: center;\r\n  line-height: 3.5;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  color: #b4b2e3;\r\n\r\n}\r\n\r\n\r\n/* NavBar CSS */\r\nnav.navbar a.navbar-brand {\r\n  width: 50%;\r\n  padding-left: 5%;\r\n}\r\n\r\nnav.navbar .navbar-nav .nav-link.navbar-link {\r\n  font-weight: 800;\r\n  padding-right: 5%;\r\n  letter-spacing: 0.8px;\r\n  padding-top: 2.2%;\r\n  font-size: 18px;\r\n  opacity: 0.75;\r\n  color: #b4b2e3;\r\n}\r\n\r\nnav.navbar .navbar-nav a.nav-link.navbar-link:hover,\r\nnav.navbar .navbar-nav a.nav-link.navbar-link.active {\r\n  opacity: 1;\r\n}\r\n\r\nspan.navbar-text {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-text button {\r\n  font-weight: 700;\r\n  color: #fff;\r\n  border: 1px solid #fff;\r\n  padding: 2% 2%;\r\n  font-size: 1em;\r\n  margin-left: 1%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  transition: 0.3s ease-in-out;\r\n}\r\n\r\n.navbar-text button span {\r\n  z-index: 1;\r\n}\r\n\r\n.navbar-text button::before {\r\n  content: \"\";\r\n  width: 0%;\r\n  height: 100%;\r\n  position: absolute;\r\n  background-color: #b4b2e3;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: -1;\r\n  transition: 0.3s ease-in-out;\r\n  color: #b4b2e3;\r\n}\r\n\r\n.navbar-text button:hover {\r\n  color: #121212;\r\n}\r\n\r\n.navbar-text button:hover::before {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n}\r\n\r\nnav.navbar .navbar-toggler:active,\r\nnav.navbar .navbar-toggler:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\nnav.navbar .navbar-toggler-icon {\r\n  width: 24px;\r\n  height: 17px;\r\n  background-image: none;\r\n  position: relative;\r\n  border-bottom: 2px solid #fff;\r\n  transition: all 300ms linear;\r\n  top: -2px;\r\n}\r\n\r\nnav.navbar .navbar-toggler-icon:focus {\r\n  border-bottom: 2px solid #fff;\r\n}\r\n\r\nnav.navbar .navbar-toggler-icon:after,\r\nnav.navbar .navbar-toggler-icon:before {\r\n  width: 24px;\r\n  position: absolute;\r\n  height: 2px;\r\n  background-color: #fff;\r\n  top: 0;\r\n  left: 0;\r\n  content: '';\r\n  z-index: 2;\r\n  transition: all 300ms linear;\r\n}\r\n\r\nnav.navbar .navbar-toggler-icon::after {\r\n  top: 8px;\r\n}\r\n\r\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon::after {\r\n  transform: rotate(45deg);\r\n  border-color: #fff;\r\n  height: 2px;\r\n}\r\n\r\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon::before {\r\n  transform: translateY(8px) rotate(-45deg);\r\n  border-color: #fff;\r\n  height: 2px;\r\n}\r\n\r\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon {\r\n  border-color: transparent;\r\n}\r\n\r\nnav.navbar.scrolled {\r\n  position: fixed;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n/* BANNER */\r\n\r\nhr.solid {\r\n  border-top: 5px solid #808080;\r\n  padding: 0;\r\n  padding-bottom: 1%;\r\n  z-index: 0;\r\n}\r\n\r\n.banner {\r\n  align-items: center;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 100%;\r\n\r\n\r\n  .section-container {\r\n    padding: 6px;\r\n    position: relative;\r\n    text-align: center;\r\n    color: white;\r\n\r\n    .centered {\r\n      position: absolute;\r\n      width: 100%;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n    }\r\n\r\n    img {\r\n      width: 100%;\r\n      z-index: 0;\r\n    }\r\n\r\n    .centered p {\r\n      text-decoration: none;\r\n      color: white !important;\r\n      font-size: 60px;\r\n      font-weight: 7400;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n\r\n/* SECTIONS*/\r\n.sections {\r\n\r\n  h2 {\r\n    padding-top: 4%;\r\n    padding-bottom: 4%;\r\n    font-weight: 200;\r\n    color: #b4b2e3;\r\n  }\r\n\r\n  img {\r\n    padding: 10px 10px 10px 10px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  p {\r\n    font-size: 1.1em;\r\n    margin-top: 5px;\r\n    letter-spacing: 0.8px;\r\n    line-height: 1.5em;\r\n    text-align: justify;\r\n    text-justify: inter-word;\r\n    padding-left: 22%;\r\n    padding-right: 22%;\r\n  }\r\n\r\n  .illustration {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .firstRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 3fr;\r\n\r\n      .twoImages {\r\n        display: block;\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .threeImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeImages {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .enviromentDesign {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .firstRow {\r\n      display: grid;\r\n      grid-template-columns: 1.3fr 1.7fr;\r\n\r\n      .twoImages {\r\n        display: block;\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .threeImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeImages {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .characterDesign {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .firstRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 2fr;\r\n\r\n      .twoImages {\r\n        display: block;\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .threeImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeImages {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n\r\n    .twoImages-2-1 {\r\n      display: grid;\r\n      grid-template-columns: 2fr 1fr;\r\n    }\r\n  }\r\n\r\n  .dWork {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .firstRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 2fr;\r\n\r\n      .twoImages {\r\n        display: block;\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .threeImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    .specialRow {\r\n      display: grid;\r\n      grid-template-columns: 0.8fr 1.2fr;\r\n\r\n      .threeImages {\r\n        display: block;\r\n        grid-template-columns: 1fr 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeImages {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .NDA {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .twoImages2 {\r\n      display: grid;\r\n      grid-template-columns: 1.34fr 0.76fr;\r\n    }\r\n\r\n    .twoImages-1-3 {\r\n      display: grid;\r\n      grid-template-columns: 1fr 2fr;\r\n    }\r\n\r\n  }\r\n\r\n  .specialRow {\r\n    display: grid;\r\n    grid-template-columns: 0.89fr 2.11fr;\r\n\r\n    .twoImages {\r\n      display: block;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n  }\r\n\r\n  .specialRow2 {\r\n    display: grid;\r\n    grid-template-columns: 1.4fr 1.6fr;\r\n\r\n    .twoImages {\r\n      display: block;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n/* FOOTER */\r\n\r\n.footer {\r\n  width: 100%;\r\n\r\n  .social-icon {\r\n    margin-top: 1%;\r\n    display: inline-block;\r\n    margin-left: 14px;\r\n    margin-bottom: 20px;\r\n    width: 100%;\r\n  }\r\n\r\n  .social-icon a {\r\n    display: inline-flex;\r\n    width: 55px;\r\n    height: 55px;\r\n    background: rgba(217, 217, 217, 0.1);\r\n    margin-right: 3%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    line-height: 1;\r\n  }\r\n\r\n  .social-icon a::before {\r\n    background-color: #D3D3D3;\r\n    border-radius: 50%;\r\n    transform: scale(0);\r\n    width: 55x;\r\n    height: 55px;\r\n    position: absolute;\r\n    transition: 0.3s ease-in-out;\r\n  }\r\n\r\n  .social-icon a img {\r\n    z-index: 1;\r\n    width: 80%;\r\n    transition: 0.3s ease-in-out;\r\n  }\r\n\r\n  .social-icon a:hover img {\r\n    filter: brightness(0.5) saturate(20%);\r\n  }\r\n\r\n}\r\n\r\nfooter {\r\n  width: 100%;\r\n}\r\n\r\n\r\n/* ABOUT */\r\n\r\n.about {\r\n  padding-left: 11%;\r\n  padding-right: 11%;\r\n\r\n  .aboutBox {\r\n    margin: 2% auto;\r\n    border-radius: 5px;\r\n    padding: 1%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    display: grid;\r\n    grid-template-columns: 1.7fr 1fr;\r\n    padding-left: 3%;\r\n    padding-right: 2%;\r\n    padding-top: 2%;\r\n    padding-bottom: 2%;\r\n    background-color: #f6cd45;\r\n    background: #f6cd45;\r\n    border-radius: 30px;\r\n\r\n\r\n    .leftBox {\r\n      background-color: #f6cd45;\r\n      position: relative;\r\n    }\r\n\r\n    .righBox {\r\n      background-color: #f6cd45;\r\n    }\r\n\r\n    .aboutLinks {\r\n      background: #f6cd45;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      position: absolute;\r\n      bottom: 0;\r\n      align-items: flex-end;\r\n    }\r\n\r\n\r\n    .contact {\r\n      background: #f6cd45;\r\n    }\r\n\r\n    .social-icon {\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      padding-right: 16%;\r\n      background-color: #f6cd45;\r\n      position: relative;\r\n    }\r\n\r\n    .social-icon a {\r\n      width: 3.5em;\r\n      height: 3.5em;\r\n      background: #f6cd45;\r\n      margin-right: 3%;\r\n      align-items: center;\r\n      justify-content: center;\r\n      line-height: 1;\r\n    }\r\n\r\n    .social-icon a img {\r\n      width: 80%;\r\n      background-color: #f6cd45;\r\n    }\r\n\r\n    .social-icon a:hover img {\r\n      background-color: #0932ba;\r\n      filter: invert(1);\r\n    }\r\n\r\n    .photo {\r\n      border-radius: 15px;\r\n    }\r\n\r\n    a {\r\n      text-decoration: none;\r\n      color: black;\r\n    }\r\n\r\n    button {\r\n      display: flex;\r\n      width: 50%;\r\n      height: 5%;\r\n      background-color: #f6cd45;\r\n      padding-left: 4%;\r\n      padding-right: 4%;\r\n      padding-top: 3%;\r\n      padding-bottom: 3%;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 30px;\r\n      text-decoration: none;\r\n      color: black;\r\n      overflow-y: hidden;\r\n      font-weight: 800;\r\n      font-size: 1.2em;\r\n\r\n      img {\r\n        background: #f6cd45;\r\n        width: 30%;\r\n        padding-right: 7%;\r\n      }\r\n    }\r\n\r\n    button:hover {\r\n      background: #cfac3a;\r\n\r\n      img {\r\n        background: #cfac3a;\r\n      }\r\n    }\r\n\r\n    h2 {\r\n      font-size: 7em;\r\n      margin-bottom: 10%;\r\n      margin-top: 0%;\r\n      display: flex;\r\n      background-color: #f6cd45;\r\n      background: #f6cd45;\r\n    }\r\n\r\n    p {\r\n      font-size: 1.2em;\r\n      padding-right: 10%;\r\n      margin-bottom: 5%;\r\n      letter-spacing: 0.8px;\r\n      line-height: 1.5em;\r\n      text-align: justify;\r\n      text-justify: inter-word;\r\n      background-color: #f6cd45;\r\n      font-weight: 800;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1500px) {\r\n  .about {\r\n    .aboutBox {\r\n      grid-template-columns: 1.9fr 0.8fr;\r\n\r\n      h2 {\r\n        font-size: 4em;\r\n      }\r\n\r\n      .photo{\r\n        margin-bottom: 20%;\r\n      }\r\n\r\n      p {\r\n        font-size: 1em;\r\n      }\r\n\r\n      button {\r\n        width: 60%;\r\n        height: 10%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1250px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n\r\n\r\n      p {\r\n        font-size: 0.9em;\r\n      }\r\n\r\n      .aboutLinks {\r\n        margin-top: 5%;\r\n      }\r\n\r\n      button {\r\n\r\n        width: 70%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .about {\r\n    .aboutBox {\r\n      .social-icon {\r\n        display: flex;\r\n        flex-direction: row;\r\n        padding-right: 0%;\r\n        padding-top: 5%;\r\n      }\r\n\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-bottom: 40%;\r\n      }\r\n      p {\r\n        font-size: 0.9em;\r\n      }\r\n\r\n      .social-icon a {\r\n        width: 2.5em;\r\n        height: 2.5em;\r\n      }\r\n\r\n      .social-icon a img {\r\n        width: 70%;\r\n      }\r\n\r\n      button {\r\n        width: 70%;\r\n        font-size: 0.9em;\r\n\r\n        img {\r\n          width: 20%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 40%;\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 816px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 120%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 760px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 160%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 625px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 250%;\r\n      }\r\n      button {\r\n        width: 70%;\r\n        font-size: 0.9em;\r\n        img {\r\n          width: 0%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 350%;\r\n      }\r\n      button {\r\n        width: 80%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 3em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 450%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 2.5em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 650%;\r\n      }\r\n      button {\r\n        width: 90%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 388px) {\r\n  .about {\r\n    .aboutBox {\r\n      h2 {\r\n        font-size: 2em;\r\n      }\r\n      .photo{\r\n        margin-top: 60%;\r\n        margin-bottom: 750%;\r\n      }\r\n      button {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* CONTACT */\r\n.contact h2 {\r\n  margin-bottom: 3%;\r\n  margin-top: 5%;\r\n  display: flex;\r\n}\r\n\r\n.contact p {\r\n  font-size: 18px;\r\n  margin-top: 5px;\r\n  letter-spacing: 0.8px;\r\n  line-height: 1.5em;\r\n  width: 96%;\r\n  text-align: justify;\r\n  text-justify: inter-word;\r\n}\r\n\r\n.contact .contact-form {\r\n  width: 100%;\r\n  margin-top: 2%;\r\n  margin-bottom: 2%;\r\n\r\n\r\n  input[type='text'],\r\n  input[type='email'] {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    height: 50px;\r\n    font-size: 16px;\r\n    padding: 0 20px;\r\n    box-sizing: border-box;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    margin-bottom: 10px;\r\n    overflow: hidden;\r\n    display: block;\r\n    position: relative;\r\n    animation-fill-mode: forwards;\r\n    border-color: transparent;\r\n    border-bottom: 1px solid\r\n  }\r\n\r\n  textarea {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n    height: 50px;\r\n    font-size: 16px;\r\n    min-height: 150px;\r\n    display: block;\r\n    box-sizing: border-box;\r\n    border-color: transparent;\r\n    border-bottom: 1px solid\r\n  }\r\n\r\n  .flat-button {\r\n    color: white;\r\n    font-size: large;\r\n    background-color: black;\r\n    font: 11px;\r\n    letter-spacing: 3px;\r\n    text-decoration: none;\r\n    padding: 8px 10px;\r\n    border: 2px solid black;\r\n    width: auto;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.not-found {\r\n  width: 100%;\r\n  margin-top: 20px;\r\n\r\n  .flat-button {\r\n    color: white;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    font-size: large;\r\n    background-color: black;\r\n    font: 11px;\r\n    letter-spacing: 3px;\r\n    text-decoration: none;\r\n    padding: 8px 10px;\r\n    border: 2px solid black;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n\r\n/*  LOGIN  */\r\n.login {\r\n\r\n  .login-container {\r\n    max-width: 400px;\r\n    margin: 2% auto;\r\n    border-radius: 5px;\r\n    padding: 1%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    background-color: #f4f1e0;\r\n  }\r\n\r\n  h2 {\r\n    text-align: center;\r\n    margin-bottom: 6%;\r\n    font-weight: lighter;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 6%;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    font-weight: bold;\r\n  }\r\n\r\n  input[type=\"text\"],\r\n  input[type=\"password\"] {\r\n    width: 100%;\r\n    padding: 2%;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  button {\r\n    width: 30%;\r\n    padding: 2%;\r\n    background-color: black;\r\n    color: #fff;\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  button:hover {\r\n    background-color: #222222;\r\n  }\r\n\r\n  span {\r\n    display: block;\r\n    padding-top: 3%;\r\n    font-size: 1.2em;\r\n    color: red;\r\n    margin-top: 1%;\r\n  }\r\n}\r\n\r\n\r\n/* POP UP MODAL */\r\n\r\n.sections {\r\n  .modal {\r\n    left: 0;\r\n    overflow-y: hidden;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    /*  to hide first time   */\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .modal-content {\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    max-width: calc(100% - 7%);\r\n    max-height: calc(100% - 7%);\r\n\r\n    img {\r\n      background-color: white;\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  .close {\r\n    position: fixed;\r\n    width: 10%;\r\n    height: 11%;\r\n    background-color: transparent;\r\n    color: #a9a9b5;\r\n    border: none;\r\n    cursor: pointer;\r\n    top: 1%;\r\n    right: 1%;\r\n    font-size: 3em;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* APPLICATION */\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
